import { encodeArk } from '@fs/zion-ark'

export default function encodedArk(group) {
  if (!group) {
    return null
  }

  let ark

  try {
    if (group?.imageApids?.length > 0) {
      // Always go to first image in image organize
      ark = encodeArk(group.imageApids[0])
    } else {
      ark = encodeArk(group.id)
    }
  } catch (e) {
    ark = group.id
  }

  return ark
}
